import { render, staticRenderFns } from "./RequestYandexExecutorJournal.vue?vue&type=template&id=bafec614&"
import script from "./RequestYandexExecutorJournal.vue?vue&type=script&lang=js&"
export * from "./RequestYandexExecutorJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QTable} from 'quasar'
component.options.components = Object.assign({QItem,QTable}, component.options.components || {})
